import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

export const SecurityReadings = createAsyncThunk(
  "bill/SecurityReading",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      let response;

      if (id) {
        // Update an existing security-charge bill record
        response = await axios.post(
          `${BASE_URL}/update-security-reading/${id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } else {
        // Create this cycle's security-charge bill record
        response = await axios.post(`${BASE_URL}/security-reading`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const SecurityReading = createSlice({
  name: "SecurityReading",
  initialState: {
    loading: false,
    SecurityReading: [],
    error: "",
  },
  extraReducers: {
    [SecurityReadings.fulfilled]: (state, action) => {
      state.SecurityReading = action.payload;
      state.loading = false;
    },
    [SecurityReadings.pending]: (state) => {
      state.loading = true;
    },
    [SecurityReadings.rejected]: (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    },
  },
});
export default SecurityReading.reducer;
